import React from 'react';
import { VyEmptyState } from '../new-design/data-display/VyEmptyState';
import { SheetWithMagnifier } from '@vy/ui-design-system';

export const EmptyTableOverlay: React.FC = () => {
  return (
    <VyEmptyState
      title="No search results found"
      icon={<SheetWithMagnifier />}
      description="Try double-checking your keywords or clearing filters."
      titleSx={{
        fontSize: '16px !important',
        fontWeight: 600,
      }}
      descriptionSx={{
        fontSize: '14px !important',
        color: '#7E8796',
      }}
    />
  );
};
